import React, { type FC } from 'react';
import { injectIntl, type WrappedComponentProps } from 'react-intl';

import { cssMap } from '@atlaskit/css';
import { Box, Stack } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import GenericError from '../../assets/GenericError.svg';

import { i18n } from './contentStateMenuV2I18n.ts';

const styles = cssMap({
	dialog: {
		maxWidth: '280px',
		paddingBlockStart: token('space.200'),
		paddingBlockEnd: token('space.100'),
		paddingInline: token('space.200'),
	},
	message: {
		color: token('color.text.disabled'),
		textAlign: 'center',
		margin: token('space.150'),
	},
});

const ContentStateMenuV2DisabledViewComponent: FC<WrappedComponentProps> = ({
	intl: { formatMessage },
}) => {
	return (
		<Stack xcss={styles.dialog} alignInline="center" testId="content-state-disabled-v2">
			<Box
				as="img"
				height={token('space.1000')}
				width={token('space.800')}
				src={GenericError}
				alt={formatMessage(i18n.featureDisabledImg)}
			/>
			<Box as="p" xcss={styles.message}>
				{formatMessage(i18n.featureDisabled)}
			</Box>
		</Stack>
	);
};

export const ContentStateMenuV2DisabledView = injectIntl(ContentStateMenuV2DisabledViewComponent);
